import * as ReactDOM from 'react-dom';
import React, { Component, useState, useEffect,createElement  } from 'react';
import './common.css';
import Usersession from './Usersession';
import axios from 'axios';
import Configdata from './Defaultdata';
import chatlnpfp from './Userpfpc';
import usrf1 from './imgs/grlpfp.png';
import usrm1 from './imgs/boypfp.png';
import {unmountComponentAtNode} from 'react-dom';
import {rvmr,insertpost} from './userdefaultdata';

export const getusermsgs=(txt:any)=>{
var userchats = [ 
		{
		mid:0,mrcvuserid:0,msndruserid:0,mmsg:"",mccd:"",mpfpid:0,misf:true,mrs:0,misread:0,msts: 0
		}		 
		];
var selecttedids = '';
const tuserid = Usersession.getUserId();
function seletmsgs(e:any,mid:any){
 e.target.style.backgroundColor = 'red';
 if (selecttedids=='')
 selecttedids += mid;
else
 selecttedids += ','+mid;
 const dv = document.getElementById('deletemsgrp') as HTMLElement;
dv.style.display='block';
 

 e.preventDefault();

}
function deletemsgs(e:any){
 const dids = selecttedids;
 const apurl ="/deletepvtmsgs";
 const obj = {msids:dids};
 insertpost(apurl,obj);
// alert(selecttedids);
}
if(txt) userchats = txt;
return(
     <div>
      <div className="per100" id="postmain">
       <div style={{width:'100%',height:'auto'}}>
      
	<div id="deletemsgrp" style={{width:'40%',float:'right',display:'none'}}>
		 <a href="#" className="blanka" onClick={e =>deletemsgs(e)}>
			<span className="deletemsg">Delete</span>
		</a>
	</div>
      
	</div>
	 <div className="postinchat" style={{overflowX:'hidden',overflowY:'auto',height:''}}>
	  <div className="postingchatdiv">

	    <table className="postingtable">
		
		
		
		<tbody>
			{userchats.map((row,index)=>(
			<tr>
			  <td>
                           {tuserid == row.msndruserid?(
         <div onClick={e =>seletmsgs(e,row.mid)} className="p-usr-msg-row" style={{color:row.mccd,float:'right',textAlign:'right'}}>
				{row.mmsg}
			    </div>	
			    ):(
	<div onClick={e =>seletmsgs(e,row.mid)} className="p-usr-msg-row" style={{color:row.mccd,float:'left',textAlign:'left'}}>
				{row.mmsg}
			    </div>
			    )}

                            
			   </td>
			</tr>
			))}
		 </tbody>	
		
	   </table>
	 </div>		
	</div>
	
	</div>

     </div>
);

}
export const gstchaddtoboat=(chats:any)=>{
}


export const scrolldowncboat=()=>{
const buffer = document.getElementById('chatdives') as HTMLElement;
if(buffer){

 buffer.scrollTop = buffer.scrollHeight;
}

}


